<template>
    <a v-if="media < 992" href="#" @click.prevent="redirect('notification-component')" class="auth__office-link">
        <span class="auth__office-count" v-html="getNotifications.length"></span>
        <svg width="22" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.8589 16.588L15.5119 13.8728L15.4283 9.09099C15.431 9.05872 15.431 9.0263 15.4283 8.99403C14.6888 5.20009 12.3483 3.0304 8.99823 3.0304C5.46169 3.0304 2.61959 5.45463 1.92515 8.9819C1.92167 9.01819 1.92167 9.05471 1.92515 9.09099L1.84156 13.9395L0.0861467 16.6546C0.0297111 16.7468 0 16.8513 0 16.9577C0 17.064 0.0297111 17.1685 0.0861467 17.2607C0.14061 17.3545 0.22046 17.4331 0.317585 17.4885C0.414711 17.5438 0.52565 17.574 0.639133 17.5758H6.4262C6.4262 18.2188 6.69718 18.8354 7.17953 19.29C7.66188 19.7447 8.31608 20.0001 8.99823 20.0001C9.68037 20.0001 10.3346 19.7447 10.8169 19.29C11.2993 18.8354 11.5703 18.2188 11.5703 17.5758H17.3573C17.4785 17.5755 17.5971 17.5429 17.6995 17.4818C17.8019 17.4207 17.8839 17.3335 17.936 17.2304C17.9888 17.1274 18.0096 17.0123 17.9959 16.8987C17.9823 16.785 17.9347 16.6773 17.8589 16.588ZM8.99823 18.788C8.65715 18.788 8.33005 18.6602 8.08888 18.4329C7.8477 18.2056 7.71221 17.8973 7.71221 17.5758H10.2842C10.2842 17.8973 10.1487 18.2056 9.90757 18.4329C9.6664 18.6602 9.3393 18.788 8.99823 18.788ZM1.77726 16.3637L3.06327 14.4001C3.12106 14.3083 3.15211 14.2038 3.15329 14.097L3.21116 9.1516C3.7963 6.21221 6.11755 4.24252 8.99823 4.24252C12.6184 4.24252 13.7758 7.27282 14.1423 9.1516L14.2323 14.097C14.2331 14.2338 14.283 14.3662 14.3738 14.4728L16.007 16.3637H1.77726Z" fill="#929292"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6844 3.29885V1.6331C10.6844 0.718562 9.85287 0 8.87674 0C7.90061 0 7.06909 0.751224 7.06909 1.6331V3.26619L8.84059 4.01742L10.6844 3.29885ZM8.84059 0.979858C8.44291 0.979858 8.11753 1.27381 8.11753 1.6331L8.08138 3.10288C8.58752 3.03756 9.05751 3.03756 9.56365 3.10288V1.6331C9.56365 1.27381 9.23827 0.979858 8.84059 0.979858Z" fill="#929292"/>
        </svg>
    </a>
    <div v-else class="auth__office-item auth__office-item--notice"
         @mouseover="hover = true"
         @mouseleave="hover = false"
    >
        <a href="#" class="auth__office-link">
            <span class="auth__office-count">{{ getNotifications.length }}</span>
            <svg width="22" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.8589 16.588L15.5119 13.8728L15.4283 9.09099C15.431 9.05872 15.431 9.0263 15.4283 8.99403C14.6888 5.20009 12.3483 3.0304 8.99823 3.0304C5.46169 3.0304 2.61959 5.45463 1.92515 8.9819C1.92167 9.01819 1.92167 9.05471 1.92515 9.09099L1.84156 13.9395L0.0861467 16.6546C0.0297111 16.7468 0 16.8513 0 16.9577C0 17.064 0.0297111 17.1685 0.0861467 17.2607C0.14061 17.3545 0.22046 17.4331 0.317585 17.4885C0.414711 17.5438 0.52565 17.574 0.639133 17.5758H6.4262C6.4262 18.2188 6.69718 18.8354 7.17953 19.29C7.66188 19.7447 8.31608 20.0001 8.99823 20.0001C9.68037 20.0001 10.3346 19.7447 10.8169 19.29C11.2993 18.8354 11.5703 18.2188 11.5703 17.5758H17.3573C17.4785 17.5755 17.5971 17.5429 17.6995 17.4818C17.8019 17.4207 17.8839 17.3335 17.936 17.2304C17.9888 17.1274 18.0096 17.0123 17.9959 16.8987C17.9823 16.785 17.9347 16.6773 17.8589 16.588ZM8.99823 18.788C8.65715 18.788 8.33005 18.6602 8.08888 18.4329C7.8477 18.2056 7.71221 17.8973 7.71221 17.5758H10.2842C10.2842 17.8973 10.1487 18.2056 9.90757 18.4329C9.6664 18.6602 9.3393 18.788 8.99823 18.788ZM1.77726 16.3637L3.06327 14.4001C3.12106 14.3083 3.15211 14.2038 3.15329 14.097L3.21116 9.1516C3.7963 6.21221 6.11755 4.24252 8.99823 4.24252C12.6184 4.24252 13.7758 7.27282 14.1423 9.1516L14.2323 14.097C14.2331 14.2338 14.283 14.3662 14.3738 14.4728L16.007 16.3637H1.77726Z" fill="#929292"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6844 3.29885V1.6331C10.6844 0.718562 9.85287 0 8.87674 0C7.90061 0 7.06909 0.751224 7.06909 1.6331V3.26619L8.84059 4.01742L10.6844 3.29885ZM8.84059 0.979858C8.44291 0.979858 8.11753 1.27381 8.11753 1.6331L8.08138 3.10288C8.58752 3.03756 9.05751 3.03756 9.56365 3.10288V1.6331C9.56365 1.27381 9.23827 0.979858 8.84059 0.979858Z" fill="#929292"/>
            </svg>
        </a>
        <transition name="fade">
            <div class="notice notice--notofication" v-show="hover">
                <div class="notice__item">
                    <div class="notice__item-header d-flex">
                        <div class="notice__item-title">
                            Мои уведомления
                        </div>

                        <!--  TODO Ссылка на страницу все оповещений   -->
                        <a href="#" @click.prevent="redirect('notification-component')" class="notice__see-all">Смотреть все</a>
                    </div>
                    <div class="notice__item-body" v-if="getNotifications.length">


                        <!--  TODO Под изображением юзера и иконкой есть бекграунды, через класы CSS   -->
                        <div class="notice__message d-flex" v-for="notice in getNotifications"
                            :key="notice.id">

                            <div style="cursor: pointer" class="notice__message-img" @click="readNotifications(notice.id)" v-if="notice.sender">
                                <img :src="'/storage/' + notice.sender.avatar.path"
                                     :alt="notice.sender.name"
                                     v-if="notice.sender.avatar">
                                <span class="pm" v-html="getUserPM(notice.sender.name)"></span>
                            </div>
                            <div style="cursor: pointer" class="notice__message-img" @click="readNotifications(notice.id)" v-else>
                                <span class="pm" v-html="getUserPM('Администратор')"></span>
                            </div>

                            <div class="notice__message-content">
                                <div class="notice__message-text" v-if="notice.type === 'pet_history_update' || notice.type === 'project_history_update'">

                                    <a :href="`/volunteer/${notice.sender_id}/profile`" class="notice__message-name" v-text="notice.sender.name" v-if="notice.sender"></a>
                                    <span class="notice__message-name" v-else>Администратор</span>
                                    <span v-text="notice.text"></span>

                                    <span>{{notice.details.history_title}}</span>
                                </div>


                                <div class="notice__message-text" v-else-if="notice.type === 'comment'">

                                    <a :href="`/volunteer/${notice.sender_id}/profile`" class="notice__message-name" v-text="notice.sender.name" v-if="notice.sender"></a>
                                    <span class="notice__message-name" v-else>Администратор</span>
                                    <span v-text="notice.text"></span>

                                    <span>{{notice.details.comment}}</span>
                                </div>

                                <div class="notice__message-text" v-else-if="notice.type === 'donorship'">

                                    <a :href="`/volunteer/${notice.sender_id}/profile`" class="notice__message-name" v-text="notice.sender.name" v-if="notice.sender"></a>
                                    <span class="notice__message-name" v-else>Администратор</span>
                                    <span v-text="notice.text"></span>

                                    <span>{{notice.details.comment}}</span>
                                </div>

                                <div class="notice__message-text" v-else>

                                    <a :href="`/volunteer/${notice.sender_id}/profile`" class="notice__message-name" v-text="notice.sender.name" v-if="notice.sender"></a>
                                    <span class="notice__message-name" v-else>Администратор</span>
                                    <span v-text="notice.text"></span>

                                </div>


                                <!--  TODO Животное юзера   -->
                                <div class="notice__message-pet" v-html="notice.petsName"></div>
                                <div class="notice__message-time">
                                    {{getNoticeDate(notice.created_at)}}
                                </div>
                                <!--  TODO Иконка по типу оповещения, метод getNotificationInfo() из notificationTypes[]  -->
                                <span class="notice__message-icon" :style="{backgroundColor: getNotificationInfo(notice).color}">
                                    <img :src="getNotificationInfo(notice).icon" alt="">
                                </span>
                            </div>
                        </div>

                    </div>
                    <div v-else class="notice__item-body notice__item-body--empty d-flex">
                        У вас нет новых уведомлений
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'

    export default {
        name: 'Notice',
        props:['mobile'],
        data(){
            return {
                hover: false,
                media: '',
                markedInfo: false,
                markedPayments: false,
            }
        },

        created() {
            window.addEventListener("resize", this.myEventHandler);
            window.addEventListener("load", this.myEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.myEventHandler);
            window.removeEventListener("load", this.myEventHandler);
        },
        mounted() {

            if( window.auth ){

                this.fetchNotifications()

            }

            this.myEventHandler()
        },
        computed:{
            ...mapGetters(['getNotifications']),
            currentUserData() {
                return this.$store.getters.getUserData;
            },


        },

        watch:{

            hover( val ){

                if( val && this.getNotifications.length ){

                    if( ! this.markedInfo
                        && this.getNotifications.find( e => e.status === 'unread' && e.category === 'info' && e.type !== 'broadcast' )
                    ) {
                        this.markAsRead( 'Info' );
                    }

                    if( ! this.markedPayments
                        && this.getNotifications.find( e => e.status === 'unread' && e.category === 'payments' && e.type !== 'broadcast' )
                    ) {
                        this.markAsRead( 'Payments' );
                    }

                }

            },

        },

        methods:{
            ...mapMutations({
                setComponent: 'setterProfileTab',
            }),
            ...mapActions(['fetchNotifications', 'readNotifications']),

            async redirect(component){

                if(window.location.href.indexOf(`/user/${this.currentUserData.id}/profile`) === -1){
                    window.location.href = await ( window.location.origin + `/user/${this.currentUserData.id}/profile` )
                }

                await this.setComponent(component)

            },

            markAsRead( cat ){

                try{

                    axios.post( '/api/notifications-mark-as-read', { category: cat.toLowerCase() } )
                        .then(() => { this[`marked${cat}`] = true })

                }
                catch ( _e ) {

                    console.log( _e );

                }

            },

            myEventHandler(e){
                this.media = window.innerWidth
            },

            getNoticeDate(timestamp){
                let dateUTC = Date.parse(timestamp)
                let dateNow = Date.now()

                let minutes = ((dateNow - dateUTC ) / 1000 / 60).toFixed()


                if(minutes < 60) {

                    minutes = (minutes <= 1) ? 'Сейчас' : (minutes > 1 && minutes < 5) ? `${minutes} минуты назад` : `${minutes} минут назад`;

                }else if(minutes >= 60 && minutes < 1440){

                    minutes = +(minutes / 60).toFixed()
                    minutes = (minutes <= 1) ?  `${minutes} час назад` : (minutes > 1 && minutes <  5) ? `${minutes} часа назад` : `${minutes} часов назад`;

                } else{

                    minutes = +(minutes / 1440).toFixed()
                    minutes = (minutes === 1) ?  `${minutes} день назад` : (minutes > 1 && minutes < 5) ? `${minutes} дня назад` : `${minutes} дней назад`

                }

                return minutes

            },

            getUserPM(name){
                if(!name) {
                    return '';
                }
                let nameArray = name.trim().split(' ');
                return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
            },

            getNotificationInfo(notice){

                let result = {}
                switch (notice.type){
                    case 'pet_history_update':
                    case 'project_history_update':
                        result = {
                            icon: '/assets/images/icons/heart.svg',
                            color: '#EAF1FC'
                        }
                        break;
                    case 'comment':
                        result = {
                            icon: '/assets/images/icons/message.svg',
                            color: '#F1EEF9'
                        }
                        break;
                    case 'broadcast':
                    case 'simple':
                        result = {
                            icon: '/assets/images/icons/message.svg',
                            color: '#F1EEF9'
                        }
                        break;
                    case 'transaction_done':
                    case 'expenditure_transaction':
                        result = {
                            icon: '/assets/images/icons/money.svg',
                            color: '#F4FBF0'
                        }
                        break;
                    case 'organization_entry_request':
                        result = {
                            icon: '/assets/images/icons/request.svg',
                            color: '#F1F2F4'
                        }
                        break;
                    case 'organization_entry_reply':
                        result = {
                            icon: '/assets/images/icons/attention.svg',
                            color: '#F1EEF9'
                        }
                        break;
                    case 'pet_ownership_request':
                        if(notice.moderatedObject.status === 'rejected_already_owned' || notice.moderatedObject.status === 'rejected'){
                            return  result = {
                                icon: '/assets/images/icons/rejected.svg',
                                color: '#FEF1F1'
                            }
                        }

                        if(notice.moderatedObject.status === 'accepted' || notice.moderatedObject.status === 'success_pet_owned'){
                            return  result = {
                                icon: '/assets/images/icons/yes.svg',
                                color: '#F1F2F4'
                            }
                        }

                        result = {
                            icon: '/assets/images/icons/request.svg',
                            color: '#F1F2F4'
                        }
                        break;
                    case 'essence_moderated':
                    case 'pet_ownership_reply':
                        if(notice.reply_status === "rejected"){
                            return  result = {
                                icon: '/assets/images/icons/rejected.svg',
                                color: '#FEF1F1'
                            }
                        }

                        if(notice.reply_status === "approved"){
                            return  result = {
                                icon: '/assets/images/icons/yes.svg',
                                color: '#F1EEF9'
                            }
                        }

                        result = {
                            icon: '/assets/images/icons/attention.svg',
                            color: '#FEF1F1'
                        }
                        break;
                    default:

                        if(notice.reply_status){
                            switch(notice.reply_status){
                                case 'approved':
                                    result = {
                                        icon: '/assets/images/icons/yes.svg',
                                        color: '#FEF1F1'
                                    }
                                    break;
                                case 'rejected':
                                    result = {
                                        icon: '/assets/images/icons/rejected.svg',
                                        color: '#FEF1F1'
                                    }
                                    break;
                                default:
                                    result = {
                                        icon: '/assets/images/icons/request.svg',
                                        color: '#F1F2F4'
                                    }
                            }

                            return result
                        }

                        result = {
                            icon: '/assets/images/icons/request.svg',
                            color: '#F1F2F4'
                        }


                        break;
                }

                return result

            }
        },


    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/helpers';
    .notice{


        &__message-text{
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical
        }



        .notice__message-icon{

            img{
                max-width: 15px;
            }
        }

        .notice__message-img{
            background-color: transparent;
        }


    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }

</style>
